import {
  ChangeEventHandler,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDropzone } from 'react-dropzone'
import classnames from 'classnames'
import { CheckIcon } from '@heroicons/react/solid'

import type { RenderField } from '~/types/applicationForm'

export function PhotoUploadInput({
  field,
  name,
  errors,
}: {
  field: RenderField
  name: string
  errors?: string[]
}) {
  const [filename, setFilename] = useState('')
  const [img, setImg] = useState<string>()

  const onDrop = useCallback(
    (acceptedFiles: any[], rejectedFiles: any[], event: any) => {
      setFilename(acceptedFiles[0].name)
      setImg(URL.createObjectURL(acceptedFiles[0]))
    },
    []
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
  })

  return (
    <div className="mt-8" {...getRootProps()}>
      <label className="block text-sm font-medium text-gray-700">
        {field.label}
        {field.isRequired && <span className="text-rose-500"> *</span>}
      </label>
      <div className="mt-1 flex items-center space-x-5">
        <span className="inline-block h-12 w-12 overflow-hidden rounded-full bg-gray-100">
          {img && <img src={img} alt="avatar" className="h-full w-full" />}
          {!img && (
            <svg
              className="h-full w-full text-gray-300"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
              {isDragActive && (
                <circle
                  className="text-accent-color"
                  cx="12"
                  cy="12"
                  r="12"
                  stroke="currentColor"
                  stroke-width="2"
                  fill="transparent"
                />
              )}
            </svg>
          )}
        </span>
        <button
          type="button"
          onClick={(event) => {
            event.preventDefault()
            // open()
          }}
          className="rounded-md border border-gray-300 bg-white py-2 px-3 text-sm font-medium leading-4 text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
        >
          {filename.length > 0 ? 'Change' : 'Upload'}
        </button>
      </div>
      <input
        id={name}
        name={name}
        type="file"
        className="sr-only"
        {...getInputProps()}
      />
      {errors && (
        <div className="pt-1 text-red-700" id="password-error">
          {errors[errors.length - 1]}
        </div>
      )}
    </div>
  )
}
